import CuotaSimpleIcon from '../../icons/cuotaSimple.svg';
import CuotaSimpleWithoutLegendIcon from '../../icons/cuotaSimpleWithoutLegend.svg';
import { CuotaSimpleLogoProps } from './types';

const CuotaSimpleLogo = ({ width = 80, withoutLegend = false }: CuotaSimpleLogoProps) => (
    <img src={withoutLegend ? CuotaSimpleWithoutLegendIcon : CuotaSimpleIcon} alt="Cuota simple" width={width} />
);

export default CuotaSimpleLogo;
